/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiDefUserData } from '../../models/api-def-user-data';

export interface UsersUpdateUserById$Params {

/**
 * The user ID
 */
  id: string;
      body: ApiDefUserData
}

export function usersUpdateUserById(http: HttpClient, rootUrl: string, params: UsersUpdateUserById$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiDefUserData>> {
  const rb = new RequestBuilder(rootUrl, usersUpdateUserById.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiDefUserData>;
    })
  );
}

usersUpdateUserById.PATH = '/users/{id}';
